import { isEmpty } from "ramda";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useEventListener } from "react-recipes";

import { jjLogger } from "utils/logUtils";

const useGoogleOptimize = () => {
  const [loading, setLoading] = useState(true);
  const [testValue, setTestValue] = useState({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const getTestValue = (testName) => (queryParams.has(testName) ? queryParams.get(testName) : window.GO[testName]);
  const mergeTestValue = (listTests) => {
    if (isEmpty(listTests)) return;
    jjLogger.logDebug(`useGoogleOptimize.js: mergeTestValue: listTests: ${JSON.stringify(listTests)}`);

    const tests = {};
    for (let index = 0; index < listTests.length; index += 1) {
      const testName = listTests[index];
      const value = getTestValue(testName);
      jjLogger.logDebug(
        `useGoogleOptimize.js: getTestValue - testname : ${JSON.stringify(testName)} value: ${JSON.stringify(value)}`,
      );

      if (value !== undefined) {
        tests[testName] = getTestValue(testName);
      }
    }

    jjLogger.logDebug(`useGoogleOptimize.js: mergeTestValue: tests: ${JSON.stringify(tests)}`);
    jjLogger.logDebug(`useGoogleOptimize.js: mergeTestValue: current testValue: ${JSON.stringify(testValue)}`);
    jjLogger.logDebug(
      `useGoogleOptimize.js: mergeTestValue: new value to set: ${JSON.stringify({ ...testValue, ...tests })}`,
    );
    jjLogger.logDebug(`useGoogleOptimize.js: mergeTestValue: window.GO: ${JSON.stringify(window.GO)}`);

    setTestValue({ ...window.GO, ...testValue, ...tests });
  };

  useEffect(() => {
    jjLogger.logDebug(`useGoogleOptimize.js: useEffect testValueChanged - loading: ${JSON.stringify(loading)}`);
    jjLogger.logDebug(`useGoogleOptimize.js: useEffect testValueChanged - testValue: ${JSON.stringify(testValue)}`);
  }, [testValue]);

  const updateTestValue = () => {
    jjLogger.logDebug(
      `useGoogleOptimize.js: updateTestValue windows.GO updated - window.GO: ${JSON.stringify(window.GO)}`,
    );

    if (isEmpty(window.GO)) return;

    jjLogger.logDebug(
      `useGoogleOptimize.js: updateTestValue windows.GO updated - window.GO: ${JSON.stringify(window.GO)}`,
    );
    jjLogger.logDebug(
      `useGoogleOptimize.js: updateTestValue windows.GO updated - current testValue: ${JSON.stringify(testValue)}`,
    );
    jjLogger.logDebug(
      `useGoogleOptimize.js: updateTestValue windows.GO updated - new testValue to set: ${JSON.stringify({
        ...testValue,
        ...window.GO,
      })}`,
    );

    setTestValue({ ...testValue, ...window.GO });
  };

  useEventListener("GO:updated", updateTestValue);

  const loadTest = (...args) => {
    jjLogger.logDebug(`useGoogleOptimize.js: loadTest - testName: ${JSON.stringify(args)}`);

    if (window.GO) {
      mergeTestValue(args);
      setLoading(false);
    } else {
      const waitForGO = () => {
        document.removeEventListener("GO:done", waitForGO);
        mergeTestValue(args);
        setLoading(false);
      };
      document.addEventListener("GO:done", waitForGO);
    }
  };

  return {
    loading,
    loadTest,
    testValue,
  };
};

export default useGoogleOptimize;
